<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'LanguageList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <luci-form v-if="!isLoading" v-model="item" :config="formConfig" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'LanguageList' })"></luci-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import variables from '../../helpers/variables'

const { mapGetters, mapActions } = createNamespacedHelpers('language/create')

export default {
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions,
      item: { name: '', code: '' }
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    formConfig () {
      return (
        {
          name: 'form-add-language',
          title: 'Details',
          description: 'To add a new language please fill in the form below.',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter language name', clearable: true }
            },
            {
              order: 2,
              element: 'input',
              required: true,
              name: 'code',
              label: 'code',
              inputConfig: { type: 'text', placeholder: 'Please enter the ISO 639-1 Code', clearable: true }
            }
          ]
        }
      )
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'LanguageList' })
    }
  },
  created () {
    this.reset()
  },
  methods: {
    ...mapActions([
      'create',
      'reset'
    ]),
    submitForm () {
      this.create(this.item)
    },
    resetForm () {
      this.reset()
      this.item = { name: '', code: '' }
    }
  }
}
</script>
